import Colors from "assets/Colors";
import AlertIcon from "components/icons/AlertIcon";
import Loading from "components/common/loading";
import { useTranslation } from "react-i18next";
import s from "./styles";
import { useBusinessContext } from "../../../BusinessApp";

function ArticleCell({ img, text }) {
  return (
    <s.TableCell>
      {img && text && <s.ImageContainer src={img} alt={img && "article"} />}
      {text}
    </s.TableCell>
  );
}

function ArticleRow({ name, img, subCategory, units, total, line = true }) {
  const { currencyFormat } = useBusinessContext();
  return (
    <>
      <ArticleCell text={name} img={img} />
      <s.TableCell>{subCategory}</s.TableCell>
      <s.TableCell style={{ fontWeight: 500 }}>
        {units ? `${units} u` : ""}
      </s.TableCell>
      <s.TableCell style={{ fontWeight: 500 }}>
        {total ? `${currencyFormat(total)}` : ""}
      </s.TableCell>
      {line && <s.Line />}
    </>
  );
}

function TopProducts(props) {
  const { t } = useTranslation();
  let items = [...props.items];

  if (items && items.length < 3) {
    items = items.concat([{}, {}, {}]);
    items = items.slice(0, 3);
  }
  if (!props.items || (props.items && props.items.length === 0)) {
    items = [];
  }

  return (
    <s.Container>
      {props.loading ? (
        <Loading height="200px" size="middle" />
      ) : (
        <>
          <s.Title>
            {t("containers.Dashboard.TopProducts.items")}{" "}
            <i>{t("containers.Dashboard.TopProducts.top")}</i>
          </s.Title>
          <s.TableContainer>
            <s.TableCell
              style={{
                background: Colors.BG_MENU,
              }}
            >
              {t("containers.Dashboard.TopProducts.item")}
            </s.TableCell>
            <s.TableCell
              style={{
                background: Colors.BG_MENU,
              }}
            >
              {t("containers.Dashboard.TopProducts.subCategory")}
            </s.TableCell>
            <s.TableCell
              style={{
                background: Colors.BG_MENU,
              }}
            >
              {t("containers.Dashboard.TopProducts.units")}
            </s.TableCell>
            <s.TableCell
              style={{
                background: Colors.BG_MENU,
              }}
            >
              {t("containers.Dashboard.TopProducts.total")}
            </s.TableCell>
            {items &&
              items.map((item, i) => (
                <ArticleRow
                  key={i}
                  name={item.name}
                  img=""
                  subCategory={item.subCategory}
                  units={item.units}
                  total={item.total}
                  line={i !== 2}
                />
              ))}
          </s.TableContainer>
          {(!items || items.length === 0) && (
            <s.NoItemsContainer>
              <s.NoItemsMessageCenter>
                <AlertIcon style={{ display: "block", marginBottom: "7px" }} />
                {t("containers.Dashboard.TopProducts.noData")}
              </s.NoItemsMessageCenter>
            </s.NoItemsContainer>
          )}
        </>
      )}
    </s.Container>
  );
}

export default TopProducts;
